import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
// Local imports
import moment from 'moment'
import { pdf,PDFViewer } from '@react-pdf/renderer'
import { PDFObject } from 'react-pdfobject'
import PdfGenerator from './PdfGenerator';
import { _HttpServices } from './../../../../_services/_HttpServices';
import { useHistory } from 'react-router';
import { IoIosClose, IoMdDownload } from "react-icons/io";
import { Footer } from "../../../../components/Footer";
const OctapharmaInvoiceReports = (props) => {
  const [fileName,setFileName] = useState();
  const [loaded, setPdfData] = useState(false);
  const [url, setUrl] = useState(null);
  const [blob , setBlob] = useState(null);
  const history = useHistory();
  const [noData,setNoData] = useState(true);
  useEffect(() => {
    ;(async () => {
      if(props.match.params.id){
        await _HttpServices.getData(`api/Inbound/OctapharmaInvoiceData?FileProcessID=`+props.match.params.id).then( async response => {
        if(response.data.length !== 0){
          response.data[0].AMOUNT = "$" + (response.data[0].AMOUNT*1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
          response.data[0].AdminFee = "$" + (response.data[0].AdminFee*1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
          response.data[0].ChargebacksAmount = "$" + (response.data[0].ChargebacksAmount*1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
          const blob = await pdf(<PdfGenerator data={response.data[0]}  from = 'Octapharama'/>).toBlob()
          const url = URL.createObjectURL(blob)
          setUrl(url);
          setBlob(blob);
          setNoData(false)
          let reportDateSplit = [];
          if(response.data[0].ReportDate)
            reportDateSplit = response.data[0].ReportDate.split('-')
          let fileName = "InvoiceOC" + reportDateSplit[0]+reportDateSplit[1]+reportDateSplit[2];
          setFileName(fileName);
        } else {
          setNoData(true)
        }    
      })
      }
    })()
  }, [])
  return (
    <section className="content">
      <div className="page-title">
        <h2 className="h2">Octapharma Invoice Source Data (monthly)</h2>
        { !noData ? 
            <a href={url} download={fileName+'.pdf'} type="application/pdf">
              <Button > <IoMdDownload className="icon btn-icon" /> Download PDF</Button>
            </a>
            : null
        }
        
      </div>
      <Row>
        <Col md={12}>
          <div className="card pt-2">
            <div className="card-body">
              <div className="inventory-grid">
                <Fragment>
                    <div>
                      { !noData ? 
                        <PDFObject
                          url={url}
                          fallbackLink={false}
                          containerProps={{
                            style: { height: 600 },
                          }}
                        />
                        :
                        <div className="no-data">No data found.</div>
                      }
                      
                    </div>
                </Fragment>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={12} className="text-right mt-2">
          <Button
            variant="danger"
            type="button"
            className="ml-3"
              onClick={() => history.goBack()}
          >
            <IoIosClose className="icon btn-icon" />
            Cancel
          </Button>
        </Col>
      </Row>
            
    <Footer />
    </section>
  );
};

export default OctapharmaInvoiceReports;